<template>
  <a-row :gutter="24">
    <a-col :span="24">
      <a-form-model-item label="意向承租方范围" prop="intentionLeaseRange">
        <a-checkbox-group
          v-model="form.intentionLeaseRange"
          style="width: 100%"
        >
          <a-row :gutter="[0, 12]">
            <a-col
              :span="8"
              v-for="item in dictionaries.intentionLeaseRangeList"
              :key="item.value"
            >
              <a-checkbox :value="item.value">{{ item.note }}</a-checkbox>
              <a-form-model-item
                prop="intentionLeaseRangeDesc"
                v-if="
                  item.value == 16384 &&
                  form.intentionLeaseRange.includes('16384')
                "
              >
                <a-input v-model="form.intentionLeaseRangeDesc" />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-checkbox-group>
      </a-form-model-item>
    </a-col>

    <a-col :span="24">
      <a-form-model-item
        label="潜在承租方应具备的资格条件"
        prop="qualificationCondition"
        extra="提示：承租资格条件不得有明确指向性和歧视性，不得违反公平竞争原则。"
      >
        <a-textarea
          v-model="form.qualificationCondition"
          placeholder="请输入潜在承租方应具备的资格条件"
          :rows="3"
        />
      </a-form-model-item>
    </a-col>

    <a-col :span="24">
      <a-form-model-item label="配套服务" prop="supportingServices">
        <template v-slot:extra>
          <div style="margin-top: -12px">
            <div v-if="form.supportingServices.includes('1')">
              企业征信报告需经承租方授权后，由地方征信平台“上海市联合征信有限公司”出具报告。
            </div>
            <div v-if="form.supportingServices.includes('2')">
              公证服务需经承租方同意，由公证机构对本项目租赁合同进行赋予强制执行效力的公证并出具公证书。
            </div>
          </div>
        </template>

        <a-checkbox-group v-model="form.supportingServices" style="width: 100%">
          <a-row :gutter="[0, 12]">
            <a-col :span="6" v-for="item in dictionaries.supportingServicesList" :key="item.value">
              <a-checkbox :value="item.value">{{ item.note }}</a-checkbox>
            </a-col>
          </a-row>
        </a-checkbox-group>
      </a-form-model-item>
    </a-col>
  </a-row>
</template>

<script>
export default {
  props: {
    form: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      dictionaries: {
        intentionLeaseRangeList: [
          {
            value: "1",
            note: "依法设立并有效存续的企业法人",
            classify: "ZLPT_YXCZFFW",
          },
          {
            value: "2",
            note: "具备完全民事行为能力的自然人",
            classify: "ZLPT_YXCZFFW",
          },
          {
            value: "4",
            note: "个体工商户",
            classify: "ZLPT_YXCZFFW",
          },
          {
            value: "8",
            note: "其他经济组织",
            classify: "ZLPT_YXCZFFW",
          },
          {
            value: "16",
            note: "依法设立并有效存续的境内企业法人或其分支机构",
            classify: "ZLPT_YXCZFFW",
          },
          {
            value: "16384",
            note: "其他",
            classify: "ZLPT_YXCZFFW",
          },
        ],
        supportingServicesList: [
          {
            value: "1",
            note: "征信",
            classify: "ZLPT_PTFW",
          },
          {
            value: "2",
            note: "合同公证",
            classify: "ZLPT_PTFW",
          },
        ],
      },
    };
  },
};
</script>

<style>
</style>